/**
 * Popup accessible roles.
 * @public
 */
enum PopupAccessibleRole {

	/**
	 * Represents no ARIA role.
	 * @public
	 */
	None = "None",

	/**
	 * Represents the ARIA role "dialog".
	 * @public
	 */
	Dialog = "Dialog",

	/**
	 * Represents the ARIA role "alertdialog".
	 * @public
	 */
	AlertDialog = "AlertDialog",
}

export default PopupAccessibleRole;
